<template>
  <th
      class="rotated-th"
      :class="alignClass"
      :style="thStyle"
  >
    <div class="rotated-th__inner">
      <span class="rotated-th__label">
        <slot>{{ label }}</slot>
      </span>
    </div>
  </th>
</template>

<script>
export default {
  name: 'RotatedTh',

  props: {
    label: {
      type: String,
      default: '',
    },

    rotate: {
      type: Number,
      default: -75,
    },

    width: {
      type: [Number, String],
      default: null,
    },

    alignClass: {
      type: [String],
      default: "",
    },
  },

  computed: {
    thStyle() {
      if (!this.width) return {};
      return {
        width: typeof this.width === 'number'
            ? `${this.width}px`
            : this.width,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.rotated-th {
  position: relative;
  padding: 0;
  vertical-align: bottom;
  white-space: nowrap;
}

/**
 * Anchor to the LEFT edge of the column
 */
.rotated-th__inner {
  position: absolute;
  bottom: 4px;
  left: 50%; // real left edge
  transform-origin: bottom left;
}

/**
 * Rotate THEN translate for visual balance
 */
.rotated-th__label {
  display: inline-block;
  transform:
      rotate(-75deg)
      translateY(0);
  transform-origin: bottom left;

  text-align: left;
  white-space: nowrap;

  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1;
}
</style>

